import React, { useEffect } from 'react';

import { RootState, useAppDispatch, useAppSelector } from '@/store';
import { articleStore } from '@/store/article';
import { authStore } from '@/store/auth';
import { errorStore } from '@/store/error';
import { AppHeader } from '../Presentation';
import i18n from '@/settings/i18n';

const getError = errorStore.selectors.createErrorSelector(
  authStore.asyncActions.logout.typePrefix,
);

const selector = (state: RootState) => ({
  error: getError(state.error),
});

export const AppHeaderContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentOrganization = useAppSelector(
    authStore.selectors.organizationSelector,
  );
  const me = useAppSelector(authStore.selectors.meSelector);
  const isLoggedIn = useAppSelector(authStore.selectors.isLoggedInSelector);
  const unreadCount = useAppSelector(
    articleStore.selectors.unreadCountSelector,
  );
  const childProps = useAppSelector(selector);

  const markArticlesAsRead = () => {
    dispatch(articleStore.actions.markAllAsRead());
  };

  useEffect(() => {
    dispatch(articleStore.asyncActions.fetchAll());
  }, [dispatch]);

  return (
    <AppHeader
      me={me}
      currentOrganization={currentOrganization}
      isLoggedIn={isLoggedIn}
      unreadCount={unreadCount}
      markArticlesAsRead={markArticlesAsRead}
      error={childProps.error}
      language={i18n.languages[0]}
    />
  );
};
